(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoVirtualPIIService', ReporteEvaluativoVirtualPIIService);

    ReporteEvaluativoVirtualPIIService.$inject = ['$resource'];

    function ReporteEvaluativoVirtualPIIService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/reporteVirtualPII/:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo,:grupo';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
					//console.log(data);
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteVirtualPII:id',
            	method:'PUT' 
            },
            'save': {
            	url:'apo/guardarreporteVirtualPII:id',
            	method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getRevision': {
            	url:'apo/revisionreporteVirtualPII:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'ver': {
            	url:'apo/verreporteVirtualPII:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();
